export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=60398017e351cdf2147997e0caa85b1cb7424b5675&name=fetchTypeahead!'